import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { TiplymeLogo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <TiplymeLogo />
        {sent ? (
          <div className="mt-8 rounded-2xl border border-border/60 bg-card p-6 text-center" data-testid="forgot-confirmation">
            <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-brand-green/10 text-brand-green"><MailCheck className="h-6 w-6" /></div>
            <h1 className="mt-4 font-heading text-xl font-bold">Check your inbox</h1>
            <p className="mt-2 text-sm text-muted-foreground">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            <Link to="/login"><Button variant="outline" className="mt-6 w-full rounded-full">Back to sign in</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="mt-8 font-heading text-2xl font-bold">Forgot password</h1>
            <p className="mt-1 text-sm text-muted-foreground">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="mt-1.5" placeholder="you@example.com" />
              </div>
              <Button type="submit" disabled={busy} data-testid="forgot-submit-button" className="w-full rounded-full bg-brand-green font-semibold text-white hover:bg-brand-green/90">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <Link to="/login" className="mt-6 block text-center text-sm font-semibold text-brand-green hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
